module.exports = __webpack_public_path__ + "static/grzesiak_main_3-fbe3673daa6590d9cac1f3a12b98bb95.png";